import { cva, VariantProps } from 'class-variance-authority';
import { HTMLAttributes, PropsWithChildren } from 'react';

import { useFormField } from '../../primitives/form';
import { cn } from '../../utils/cn';

const labelVariants = cva(
  'font-regular pt-[6px] pb-[6px] text-sm leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70',
);

interface LabelWithoutRefProps
  extends
    Pick<HTMLAttributes<HTMLParagraphElement>, 'className'>,
    VariantProps<typeof labelVariants> {}

export function LabelWithoutRef({
  children,
  className,
  ...props
}: PropsWithChildren<LabelWithoutRefProps>) {
  return (
    <p className={cn(labelVariants(), className)} {...props}>
      {children}
    </p>
  );
}

export function FormLabelWithoutRef({
  className,
  ...props
}: PropsWithChildren<LabelWithoutRefProps>) {
  const { error } = useFormField();

  return <LabelWithoutRef className={cn(error && 'text-destructive', className)} {...props} />;
}
